import { render, staticRenderFns } from "./company-choice.vue?vue&type=template&id=21374f09&"
import script from "./company-choice.ts?vue&type=script&lang=ts&"
export * from "./company-choice.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports